type SendStatus = "sending" | "success" | "error";

interface SendStatusModalProps {
  status: SendStatus;
  errorMessage?: string | null;
  onClose: () => void;
}

export default function SendStatusModal({ status, errorMessage, onClose }: SendStatusModalProps) {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/40">
      <div className="w-full max-w-sm rounded-lg bg-white p-6 text-center shadow-xl">
        {status === "sending" && (
          <>
            <div className="mx-auto mb-4 h-10 w-10 animate-spin rounded-full border-4 border-blue-200 border-t-blue-600" />
            <p className="text-gray-700">送信中です...</p>
          </>
        )}
        {status === "success" && (
          <>
            <div className="mx-auto mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-green-100 text-green-600 text-xl">✓</div>
            <p className="mb-4 font-medium text-gray-800">送信が完了しました</p>
            <button
              type="button"
              className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700"
              onClick={onClose}
            >
              OK
            </button>
          </>
        )}
        {status === "error" && (
          <>
            <div className="mx-auto mb-4 flex h-10 w-10 items-center justify-center rounded-full bg-red-100 text-red-600 text-xl">✕</div>
            <p className="mb-1 font-medium text-gray-800">送信に失敗しました</p>
            {errorMessage && <p className="mb-4 text-sm text-gray-500">{errorMessage}</p>}
            <button
              type="button"
              className="rounded border border-gray-300 px-4 py-2 text-gray-700 hover:bg-gray-50"
              onClick={onClose}
            >
              閉じる
            </button>
          </>
        )}
      </div>
    </div>
  );
}
